<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/">About</router-link>
  </nav> -->
  <div id="app">
    <router-view/>
  </div>
</template>
<style>
.menu-item:hover {
  background: #1890ff;
  color: #fff;
}
</style>
